import { PlatformLocation } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';
import { brandingForHostname, ProductBranding } from './product-branding';

/**
 * Branding of the product being served, resolved from the current hostname.
 * Override with `{ provide: PRODUCT_BRANDING, useValue: PRODUCT_BRANDINGS[AgoraProduct.Intelligence] }` in tests.
 */
export const PRODUCT_BRANDING = new InjectionToken<ProductBranding>('Product branding', {
  providedIn: 'root',
  factory: (): ProductBranding => brandingForHostname(inject(PlatformLocation).hostname)
});
